var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m500.879 289.165c-7.72-2.07-16.152 2.326-18.371 10.606l-.347 1.296-34.708-9.3c2.162-11.599 3.304-23.552 3.304-35.768 0-12.217-1.143-24.171-3.305-35.771l34.708-9.3.347 1.296c2.219 8.281 10.652 12.676 18.371 10.606 8.002-2.144 12.751-10.369 10.606-18.371l-8.459-31.569c-2.145-8.002-10.365-12.752-18.371-10.606-8.002 2.144-12.75 10.369-10.606 18.371l.347 1.296-34.718 9.303c-8.09-22.882-20.335-43.815-35.834-61.884l25.481-25.481.949.949c5.856 5.857 15.355 5.859 21.213 0 5.858-5.858 5.858-15.355 0-21.213l-23.11-23.11c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l.949.949-25.481 25.48c-18.071-15.5-39.005-27.746-61.888-35.835l9.302-34.716 1.296.347c8.314 2.228 16.314-2.928 18.371-10.606 2.144-8.002-2.604-16.227-10.606-18.371l-31.569-8.459c-8.003-2.145-16.228 2.605-18.371 10.606-2.144 8.002 2.604 16.227 10.606 18.371l1.296.347-9.3 34.708c-11.599-2.162-23.552-3.304-35.768-3.304s-24.169 1.142-35.768 3.304l-9.3-34.708 1.296-.347c8.002-2.144 12.75-10.369 10.606-18.371-2.143-8.003-10.368-12.753-18.37-10.608l-31.569 8.459c-8.002 2.144-12.75 10.369-10.606 18.371 2.057 7.679 10.057 12.835 18.371 10.606l1.296-.347 9.302 34.716c-22.883 8.09-43.817 20.335-61.888 35.835l-25.481-25.48.949-.949c5.858-5.858 5.858-15.355 0-21.213-5.857-5.858-15.355-5.858-21.213 0l-23.11 23.11c-5.858 5.858-5.858 15.355 0 21.213 5.858 5.859 15.357 5.857 21.213 0l.949-.949 25.481 25.481c-15.499 18.07-27.744 39.003-35.834 61.884l-34.718-9.303.347-1.296c2.144-8.002-2.604-16.227-10.606-18.371-8.006-2.146-16.227 2.604-18.371 10.606l-8.461 31.572c-2.144 8.002 2.604 16.227 10.606 18.371 7.72 2.07 16.152-2.326 18.371-10.606l.347-1.296 34.708 9.3c-2.162 11.6-3.305 23.554-3.305 35.771 0 12.216 1.142 24.169 3.304 35.768l-34.708 9.3-.347-1.296c-2.219-8.281-10.652-12.676-18.371-10.606-8.002 2.144-12.75 10.369-10.606 18.371l8.459 31.569c2.145 8.002 10.365 12.752 18.371 10.606 8.002-2.144 12.75-10.369 10.606-18.371l-.347-1.296 34.716-9.302c8.09 22.883 20.335 43.817 35.835 61.888l-25.481 25.481-.949-.949c-5.856-5.857-15.355-5.859-21.213 0-5.858 5.858-5.858 15.355 0 21.213l23.11 23.11c5.857 5.858 15.355 5.858 21.213 0s5.858-15.355 0-21.213l-.949-.949 25.481-25.48c18.071 15.5 39.005 27.746 61.888 35.835l-9.302 34.716-1.296-.347c-8.314-2.228-16.314 2.928-18.371 10.606-2.144 8.002 2.604 16.227 10.606 18.371l31.569 8.459c8.003 2.145 16.228-2.605 18.371-10.606 2.144-8.002-2.604-16.227-10.606-18.371l-1.296-.347 9.3-34.708c11.599 2.162 23.552 3.304 35.768 3.304s24.169-1.142 35.768-3.304l9.3 34.708-1.296.347c-8.002 2.144-12.75 10.369-10.606 18.371 2.144 8.001 10.368 12.751 18.371 10.606l31.569-8.459c8.002-2.144 12.75-10.369 10.606-18.371-2.057-7.679-10.057-12.835-18.371-10.606l-1.296.347-9.302-34.716c22.883-8.09 43.817-20.335 61.888-35.835l25.481 25.48-.949.949c-5.858 5.858-5.858 15.355 0 21.213 5.857 5.858 15.355 5.858 21.213 0l23.11-23.11c5.858-5.858 5.858-15.355 0-21.213-5.858-5.859-15.357-5.857-21.213 0l-.949.949-25.481-25.481c15.5-18.071 27.746-39.005 35.835-61.888l34.716 9.302-.347 1.296c-2.144 8.002 2.604 16.227 10.606 18.371 8.006 2.146 16.227-2.604 18.371-10.606l8.459-31.569c2.149-8.003-2.599-16.228-10.601-18.372zm-244.879 131.592c-90.847 0-164.757-73.91-164.757-164.757s73.91-164.757 164.757-164.757 164.757 73.91 164.757 164.757-73.91 164.757-164.757 164.757z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 143.533,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 368.467,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.867,
    cy: 288.133,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.133,
    cy: 288.133,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.133,
    cy: 223.867,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.867,
    cy: 223.867,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.467,
    cy: 256,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.533,
    cy: 256,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.526,
    cy: 176.478,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.474,
    cy: 335.53,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.526,
    cy: 335.53,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.474,
    cy: 176.478,
    r: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirus);
export default __webpack_public_path__ + "static/media/virus.90e4d287e2cfd5870d783c3ebce19a0a.svg";
export { ForwardRef as ReactComponent };